export default __webpack_public_path__ + "static/media/arrow_forward_black_-7.178037c3.png";